import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'linkify',
  standalone: true,
})
export class LinkifyPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    if (!value) return '';

    // Regex to match URLs (http, https, www)
    const urlRegex = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;
    // Regex to match emails
    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
    let escaped = this.escapeHtml(value);

    // Replace URLs
    escaped = escaped.replace(urlRegex, (url) => {
      const href = url.startsWith('www.') ? `http://${url}` : url;
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });

    // Replace Emails
    escaped = escaped.replace(emailRegex, (email) => {
      return `<a href="mailto:${email}">${email}</a>`;
    });

    // Replace Phone Numbers (only matches strings with at least 7 digits to avoid matching small numbers)
    // Matches phone numbers with international code + and spaces/dashes/dots
    const phoneRegex = /\+?\d{1,4}(?:[\s\-\.]?\d{1,5})+/g;

    escaped = escaped.replace(phoneRegex, (match) => {
      // Separate trailing punctuation like ; . , ! if any
      const trailingPunctMatch = match.match(/^(.*?)([\s;.,!?]*)$/);
      const phonePart = trailingPunctMatch ? trailingPunctMatch[1] : match;
      const punctPart = trailingPunctMatch ? trailingPunctMatch[2] : '';

      const digitsOnly = phonePart.replace(/[^\d+]/g, '');
      const digitCount = phonePart.replace(/\D/g, '').length;
      if (digitCount >= 10 && digitCount <= 15) {
        return `<a href="tel:${digitsOnly}">${phonePart}</a>${punctPart}`;
      }
      return match;
    });

    return this.sanitizer.bypassSecurityTrustHtml(escaped);
  }

  private escapeHtml(str: string): string {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}
